import React, {forwardRef} from 'react';
import {motion} from 'framer-motion';

import {Circle} from '@spothero/ui';

const FramerMotionCircle = motion(Circle);

const MotionCircle = forwardRef((props, ref) => {
    return <FramerMotionCircle {...props} ref={ref} />;
});

export default MotionCircle;
